import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, CustomRenderCountryName, DefaultTableCustomRender, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getActiveCurrenciesDictionary, getDictionaryCountries } from '../../../../../../utils/reducers/getters'
import ModalCreateWorkingCenterConnect from './ModalCreateWorkingCenter'
import { WorkingCenterModelTypeExtended } from './types'

interface WorkingCentersProps extends ComponentWithPermissions { }

const WorkingCenters: React.FC<WorkingCentersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('workingCenters', 'Centros de Trabajo'),
        newText: t('newWorkingCenter', 'Nuevo Centro de trabajo'),
    }

    return (
        <BaseScreenTable TableComponent={TableWorkingCenters} CreateModalComponent={ModalCreateWorkingCenterConnect} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableWorkingCentersProps extends TableComponentProps { }

const TableWorkingCenters: React.FC<TableWorkingCentersProps> = ({ setTableInstance }) => {
    const { t } = useTwinTranslation()
    const location = useLocation().pathname
    const countries = getDictionaryCountries()
    const memorizedCurrencies = useMemo(() => getActiveCurrenciesDictionary(), [])
    const columns: ColumnTableSchema<WorkingCenterModelTypeExtended> = [
        {
            id: 'name', 
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchKey: 'WorkingCenter.name',
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'CurrencyId',
            dataKey: 'CurrencyId',
            label: t('currency', 'Moneda'),
            customRender: (parameterValue) => <DefaultTableCustomRender items={memorizedCurrencies} value={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: memorizedCurrencies, label: t('currency', 'Moneda') }
            },
            generalSearchable: false
        },
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'city',
            dataKey: 'city',
            label: t('city', 'Ciudad'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('city', 'Ciudad') }
            },
        },
        {
            id: 'active_tpv',
            dataKey: 'active_tpv',
            label: t('tpv', 'TPV'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id', 
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        }
    ]
    return (
        <TwinTableLink name='workingCenters' createRowDataLink={[location, ['$id', 'main']]} columns={columns} getDataFrom='/api/app/workingCenter/getAllWorkingCenters'  setTableInstance={setTableInstance} />
    )
}
export default WorkingCenters